<template>
	<!-- 商户进件 -->
	<div class="merchantList">
		<!-- 表单搜索部分 -->
		<el-card class="box-card" shadow="hover">
			<el-form :inline="true" :model="searchForm" class="demo-form-inline">
				<el-form-item>
					<el-input size clearable v-model="searchForm.agent_phone" placeholder="请输入代理账号"></el-input>
				</el-form-item>
				<el-form-item>
					<el-input size clearable v-model="searchForm.agent_name" placeholder="请输入代理名称"></el-input>
				</el-form-item>
				<el-form-item>
					<el-input size clearable v-model="searchForm.agent_no" placeholder="请输入代理编号"></el-input>
				</el-form-item>
				
				<el-form-item>
					<el-select
					    v-model="searchForm.brand_id"
					    filterable
					    clearable
					    placeholder="请选择政策名称"
					>
					    <el-option
					        v-for="(item,index) in brandList"
					        :key="index"
					        :label="item.name"
					        :value="item.id"
					    ></el-option>
					</el-select>
				</el-form-item>
				
				<el-form-item>
					<el-select size v-model="searchForm.up_type" clearable placeholder="请选择调价范围">
						<el-option label="不限" value="1"></el-option>
						<el-option label="费率" value="2"></el-option>
						<el-option label="秒到费" value="3"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item>
					<el-select size v-model="searchForm.status" clearable placeholder="请选择状态">
						<el-option label="启用" value="1"></el-option>
						<el-option label="停用" value="2"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item>
					<el-date-picker v-model="rangeDate" type="datetimerange" range-separator="至"
						start-placeholder="更新开始日期" end-placeholder="更新结束日期" value-format="yyyy-MM-dd"
						@change="pickerChange"></el-date-picker>
				</el-form-item>
				<el-form-item>
					<el-button size="medium" type="primary" icon="el-icon-search" style="font-size: 12px;"
						@click="onSearch(searchForm)">查询</el-button>
					<el-button size="medium" type="primary" icon="el-icon-plus" style="font-size: 12px;"
						@click="addLimits()">添加调价权限</el-button>
				</el-form-item>
			</el-form>
		</el-card>
		<!-- 表格部分 -->
		<el-card class="box-card" style="margin-top: 20px;" shadow="hover">
			<el-table :data="marchantList" size="mini" border style="width: 100%" v-loading="loading">
				<!-- 序号 -->
				<el-table-column header-align="center" align="center" fixed type="index" label="ID"
					min-width="80"></el-table-column>
				<el-table-column header-align="center" align="center" prop="agent_phone" label="代理商账号"min-width="120"></el-table-column>
				<el-table-column header-align="center" align="center" prop="agent_name" label="代理商名称"min-width="120"></el-table-column>
				<el-table-column header-align="center" align="center" prop="agent_no" label="代理商编号"min-width="120"></el-table-column>
				<el-table-column header-align="center" align="center" prop="brand_name" label="政策名称"min-width="120"></el-table-column>
				<el-table-column header-align="center" align="center" prop="up_type" label="调价范围"min-width="120">
					<template slot-scope="scope">
						<span v-if="scope.row.up_type == 1">不限</span>
						<span v-else-if="scope.row.up_type == 2">费率</span>
						<span v-else>秒到费</span>
					</template>
				</el-table-column>
				<el-table-column header-align="center" align="center" prop="base_rate" label="基准价费率(%)"min-width="120"></el-table-column>
				<el-table-column header-align="center" align="center" prop="height_rate" label="费率最高值(%)"min-width="120"></el-table-column>
				<el-table-column header-align="center" align="center" prop="platform_divide" label="平台分成比例(%)"min-width="120"></el-table-column>
				<el-table-column header-align="center" align="center" prop="direct_divide" label="直属最低比例(%)"min-width="120"></el-table-column>
				<el-table-column header-align="center" align="center" prop="max_rate" label="调价浮动权限(%)"min-width="120"></el-table-column>
				<el-table-column header-align="center" align="center" prop="reg_day" label="商户入网天数"min-width="120"></el-table-column>
				<el-table-column header-align="center" align="center" prop="status" label="状态"min-width="120">
					<template slot-scope="scope">
						<span v-if="scope.row.status == 1">启用</span>
						<span v-else-if="scope.row.status == 2">停用</span>
					</template>
				</el-table-column>
				<el-table-column header-align="center" align="center" prop="update_time" label="更新时间"min-width="120"></el-table-column>
				
				<el-table-column header-align="center" align="center" fixed="right" label="操作" min-width="150">
					<template slot-scope="scope">
						<el-button @click="edit(scope.row)" type="text" size="small">编辑</el-button>
						<el-button @click="deactivate(scope.row)" type="text" size="small" v-if="scope.row.status == 1">停用</el-button>
					</template>
				</el-table-column>
			</el-table>
			<!-- 分页部分 -->
			<el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange"
				:page-sizes="[10,20,50,100]" :current-page="currentPage" :page-size="pageSize" :total="total"
				layout="total, sizes, prev, pager, next, jumper"></el-pagination>
		</el-card>

		<el-dialog :title="changeFree" :visible.sync="dialogVisible" width="60%" :close-on-click-modal="false"
			:before-close="handleClose">

			<el-form :inline="true" :model="formInline" label-width="120px" :rules="rules" ref="ruleForm">
				<el-row>
					<el-form-item label="代理商账号" prop="phone">
						<el-input v-model="formInline.phone" clearable @blur="agentApi"  :disabled="inputState"></el-input>
					</el-form-item>
					<el-form-item label="代理商名称" prop="agent_name">
						<el-input v-model="formInline.agent_name" disabled></el-input>
					</el-form-item>
					<el-form-item label="政策名称" prop="brand_id">
						<el-select v-model="formInline.brand_id" clearable :disabled="inputState">
							<el-option v-for="item in policyOption" :label="item.name" :value="item.id"
								:key="item.id"></el-option>
						</el-select>
					</el-form-item>
				</el-row>

				<el-row>
					<el-form-item label="调价范围" prop="up_type">
						<el-select v-model="formInline.up_type" clearable>
							<el-option label="不限" :value="1"></el-option>
							<el-option label="费率" :value="2"></el-option>
							<el-option label="秒到费" :value="3"></el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="基准价费率" prop="base_rate">
						<el-select v-model="formInline.base_rate" clearable>
							<el-option label="0.53" :value="0.53"></el-option>
							<el-option label="0.54" :value="0.54"></el-option>
							<el-option label="0.55" :value="0.55"></el-option>
							<el-option label="0.56" :value="0.56"></el-option>
							<el-option label="0.57" :value="0.57"></el-option>
							<el-option label="0.58" :value="0.58"></el-option>
							<el-option label="0.59" :value="0.59"></el-option>
							<el-option label="0.60" :value="0.60"></el-option>
							<el-option label="0.61" :value="0.61"></el-option>
							<el-option label="0.62" :value="0.62"></el-option>
							<el-option label="0.63" :value="0.63"></el-option>
							<el-option label="0.64" :value="0.64"></el-option>
							<el-option label="0.65" :value="0.65"></el-option>
							<el-option label="0.66" :value="0.66"></el-option>
							<el-option label="0.67" :value="0.67"></el-option>
							<el-option label="0.68" :value="0.68"></el-option>
							<el-option label="0.69" :value="0.69"></el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="费率最高值" prop="height_rate">
						<el-select v-model="formInline.height_rate" clearable>
							<el-option label="0.53" :value="0.53"></el-option>
							<el-option label="0.54" :value="0.54"></el-option>
							<el-option label="0.55" :value="0.55"></el-option>
							<el-option label="0.56" :value="0.56"></el-option>
							<el-option label="0.57" :value="0.57"></el-option>
							<el-option label="0.58" :value="0.58"></el-option>
							<el-option label="0.59" :value="0.59"></el-option>
							<el-option label="0.60" :value="0.60"></el-option>
							<el-option label="0.61" :value="0.61"></el-option>
							<el-option label="0.62" :value="0.62"></el-option>
							<el-option label="0.63" :value="0.63"></el-option>
							<el-option label="0.64" :value="0.64"></el-option>
							<el-option label="0.65" :value="0.65"></el-option>
							<el-option label="0.66" :value="0.66"></el-option>
							<el-option label="0.67" :value="0.67"></el-option>
							<el-option label="0.68" :value="0.68"></el-option>
							<el-option label="0.69" :value="0.69"></el-option>
						</el-select>
					</el-form-item>
				</el-row>

				<el-row>
					<el-form-item label="调价浮动权限">
						<el-select v-model="formInline.max_rate" clearable>
                            <el-option label="不限" :value="0"></el-option>
							<el-option label="0.01" :value="0.01">0.01%</el-option>
							<el-option label="0.02" :value="0.02">0.02%</el-option>
							<el-option label="0.03" :value="0.03">0.03%</el-option>
							<el-option label="0.04" :value="0.04">0.04%</el-option>
							<el-option label="0.05" :value="0.05">0.05%</el-option>
							<el-option label="0.06" :value="0.06">0.06%</el-option>
							<el-option label="0.07" :value="0.07">0.07%</el-option>
							<el-option label="0.08" :value="0.08">0.08%</el-option>
							<el-option label="0.09" :value="0.09">0.09%</el-option>
							<el-option label="0.10" :value="0.10">0.10%</el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="商户入网天数" prop="reg_day">
						<el-input v-model="formInline.reg_day" clearable></el-input>
						<span style="font-weight: 700;font-size: 12px;color: #606266;margin-left: 12px;">天，后可以调价</span>
					</el-form-item>
				</el-row>

				<el-row>
					<el-form-item label="平台分成比例" prop="platform_divide">
						<el-input v-model="formInline.platform_divide" clearable>
							<span slot="suffix">%</span>
						</el-input>
					</el-form-item>
					<el-form-item label="直属最低比例" prop="direct_divide">
						<el-input v-model="formInline.direct_divide	" clearable>
							<span slot="suffix">%</span>
						</el-input>
					</el-form-item>
					<el-form-item label="状态" prop="status">
						<el-select v-model="formInline.status" clearable>
							<el-option label="启用" :value="1"></el-option>
							<el-option label="停用" :value="2"></el-option>
						</el-select>
					</el-form-item>
				</el-row>
			</el-form>

			<span slot="footer" class="dialog-footer">
				<el-button @click="handleClose()">取 消</el-button>
				<el-button type="primary" @click="save()">确 定</el-button>
			</span>
		</el-dialog>
	</div>
</template>

<script>
	export default {
		name: "rightsManagement",
		data() {
			return {
                changeFree:'添加调价权限',
				searchForm: {
					agent_phone:'',
					agent_name:'',
					agent_no:'',
					brand_id:'',
					up_type:'',
					status: '',
					start_time: '',
					end_time: '',
				},
				rangeDate: '',
				id: '',
				marchantList: [],
				currentPage: 1, //当前页码
				pageSize: 10, //条数
				total: 0, //总数
				loading: true,
				level: sessionStorage.getItem('level'),
				brandList: [],
				//添加政策
				dialogVisible: false,
				formInline: {
					id: 0,
					user_id: '',
					agent_name: '',
					brand_id: '',
					status: 1,
					up_type: 1,
				},
				inputState:false,
				//政策
				policyOption: [],
				rules: {
					phone: [{
						required: true,
						message: '请输入代理商账号',
						trigger: 'blur'
					}],
					brand_id: [{
						required: true,
						message: '请选择政策',
						trigger: 'change'
					}],
					up_type: [{
						required: true,
						message: '请选择调价范围',
						trigger: 'change'
					}],
					base_rate: [{
						required: true,
						message: '请选择基准价费率',
						trigger: 'change'
					}],
					height_rate: [{
						required: true,
						message: '请选择费率最高值',
						trigger: 'change'
					}],
					reg_day: [{
						required: true,
						message: '请输入商户入网天数',
						trigger: 'blur'
					}],
					platform_divide: [{
						required: true,
						message: '请输入平台分成比例',
						trigger: 'blur'
					}],
					direct_divide: [{
						required: true,
						message: '请输入直属最低比例',
						trigger: 'blur'
					}],
					status: [{
						required: true,
						message: '请选择状态',
						trigger: 'change'
					}],
				}
			}
		},
		created() {

		},
		mounted() {
			this.$api.post('brand/brand_list', {}, res => { //获取终端类型
			    if (res.code == 0) {
			        this.brandList = res.data.list;
			    } else {
			        this.$message.success(res.msg);
			    }
			});
			this.getData({
				page: 1,
				limit: 10
			})
		},
		methods: {
			onSearch(searchFrom) {
				this.currentPage = 1;
				searchFrom.page = 1;
				this.getData(searchFrom);
			},
			getData(params) { //获取数据
				this.loading = true;
				this.$api.post("rateup/policyList", params, res => {
					let data = res.data;
					this.total = data.count; //总数
					this.marchantList = res.data.list;
					//渲染结束后取消加载
					this.loading = false;
				})
			},
			handleCurrentChange(page) { //当前选中页
				this.currentPage = page;
				this.searchForm.page = page;
				this.searchForm.limit = this.pageSize;
				this.getData(this.searchForm);
			},
			handleSizeChange(limit) { //条数
				this.currentPage = 1;
				this.pageSize = limit;
				this.searchForm.page = 1;
				this.searchForm.limit = limit;
				this.getData(this.searchForm);
			},
			pickerChange(DateArr) { //时间选择器
				this.searchForm.start_time = this._.isEmpty(DateArr) ? '' : DateArr[0];
				this.searchForm.end_time = this._.isEmpty(DateArr) ? '' : DateArr[1];
			},

			//新增调价权限
			addLimits() {
                this.changeFree ='添加调价权限'
				this.inputState = false;
				this.dialogVisible = true;
			},
			//关闭弹框
			handleClose() {
				this.dialogVisible = false;
				this.$refs['ruleForm'].resetFields();
				this.formInline = {
					user_id: "",
					status: 1,
					up_type: 1,
					id: 0,
				}
			},
			//输入代理商编号查询数据
			agentApi() {
				this.$api.post("rateup/getBrand", {
					phone: this.formInline.phone
				}, res => {
					if (res.data) {
						if (res.data) {
							this.formInline.user_id = res.data.user_id;
							this.formInline.agent_name = res.data.nickname;
							this.policyOption = res.data.brand_list
						} else {
							this.formInline.user_id = null;
							this.formInline.agent_name = null;
							this.formInline.brand_id = null;
							this.policyOption = [];
						}
					}
				})
			},
			//保存
			save() {
				if (this.formInline.max_rate == "") {
					this.formInline.max_rate = 0;
				}
				this.$refs['ruleForm'].validate((valid) => {
					if (valid) {
						this.$api.post("rateup/savePolicy", this.formInline, res => {
							if (res.code == 0) {
								this.$message.success(res.msg);
								this.handleClose();
								this.getData({
									page: 1,
									limit: 10
								})
							} else {
								this.$message.error(res.msg);
							}
						})
					} else {
						return false;
					}
				});
			},
			//停用
			deactivate(row) {
				this.$confirm("确定停用政策,不可恢复,请谨慎操作?", '提 示', {
					type: 'warning',
					distinguishCancelAndClose: true,
					confirmButtonText: '确 定',
					cancelButtonText: '取 消'
				}).then(() => {
					this.$api.post("rateup/editPolicyStatus", {id:row.id}, res => {
						if (res.code == 0) {
							this.$message.success(res.msg);
							this.getData({
								page: 1,
								limit: 10
							})
						} else {
							this.$message.error(res.msg);
						}
					})
				}).catch(() => {})
			},
			//编辑
			edit(row){
                this.changeFree ='编辑调价权限'
				this.$api.post("rateup/getPolicy", {id:row.id}, res => {
					if (res.code == 0) {
						this.formInline = res.data;
						this.agentApi();
						this.inputState = true;
						this.dialogVisible = true;
					}
				})
			}
		}
	}
</script>

<style scoped lang="scss">
	.el-form-item {
		margin-bottom: 20px;
	}

	.el-select,
	.el-input {
		width: 180px;
		font-size: 12px;
	}
</style>